import { API_ENDPOINTS } from "@/api/services/attendance/apiEndPoint";
import { baseApi } from "@/utils/baseApi";


export const calendarListApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({
    getCalendar: builder.query({
      query: ({ empIds, dateObj }) =>({ url: API_ENDPOINTS.ATTENDANCE.GET_CALENDAR(empIds, dateObj),
        }),
        providesTags: ["Calendar"]
    }),
    // GET_PAYROLL_LOCK_DATE
    getPayrollLockDate: builder.query({
      query: ({ yearMonth }) =>({ 
        url: API_ENDPOINTS.ATTENDANCE.GET_PAYROLL_LOCK_DATE(yearMonth),
      }),
    }),

    getPayrollLockDateInfo: builder.query({
      query: ({ yearMonth }) => ({ 
       url: API_ENDPOINTS.ATTENDANCE.GET_PAYROLL_LOCK_DATE_INFO(yearMonth),
      }),
    }),

    postEmployeeSigning: builder.mutation({
      query: ({ location, isSign }) => ({
        url: API_ENDPOINTS.ATTENDANCE.POST_EMPLOYEE_SIGNING(location, isSign),
        method: "POST",
      }),
      // providesTags: ["Calendar"]
       invalidatesTags: [{ type: "WebSign", id: "LIST" }],
    }),
    getEmployeeSign: builder.query({
      query: () => ({
        url: API_ENDPOINTS.ATTENDANCE.GET_EMPLOYEE_SIGN,
        method: "GET",
      }),
      providesTags: (result) =>
          result && Array.isArray(result)
              ? [{ type: "WebSign", id: "LIST" }]
              : [{ type: "WebSign", id: "LIST" }],
      
    }),
  }),

});

export const { useGetCalendarQuery, useGetPayrollLockDateQuery, useGetPayrollLockDateInfoQuery, usePostEmployeeSigningMutation, useGetEmployeeSignQuery, useLazyGetEmployeeSignQuery } = calendarListApi;
